/**
 * mSTEM UC-43 / UC-47 manager row-action cell. Renders "Sửa" + "Xóa" text
 * buttons for one declared device/block row. Class component with bindAll so
 * per-row handlers satisfy react/jsx-no-bind without inline-arrow allocations.
 */
import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './ext-manager-modal.css';

class ExtManagerActionsCell extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, ['handleEdit', 'handleDelete']);
    }
    handleEdit (e) {
        if (e && e.stopPropagation) e.stopPropagation();
        this.props.onEdit(this.props.row);
    }
    handleDelete (e) {
        if (e && e.stopPropagation) e.stopPropagation();
        this.props.onDelete(this.props.row);
    }
    render () {
        const {editLabel, deleteLabel} = this.props;
        return (
            <div className={styles.actionsCell}>
                <button
                    className={styles.iconBtn}
                    type="button"
                    onClick={this.handleEdit}
                >
                    {editLabel}
                </button>
                <button
                    className={styles.iconBtnDanger}
                    type="button"
                    onClick={this.handleDelete}
                >
                    {deleteLabel}
                </button>
            </div>
        );
    }
}

ExtManagerActionsCell.propTypes = {
    deleteLabel: PropTypes.string.isRequired,
    editLabel: PropTypes.string.isRequired,
    onDelete: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
    row: PropTypes.shape({id: PropTypes.string.isRequired}).isRequired // eslint-disable-line react/forbid-prop-types
};

export default ExtManagerActionsCell;
